import { useEffect, useState } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { DeviceDetailsWrapper, InfoItem, InfoLabel, InfoValue } from "./DeviceDetails.styled";
import DeviceStatus from "../../../../../../components/ui-components/device-status/DeviceStatus";
import DeviceApi from "../../../../../../api/DeviceApi";
import AlarmEventApi from "../../../../../../api/AlarmEventApi";
import TimeUtils from "../../../../../../util/TimeUtils";
import BracketBorderCard from "../../common/bracket-border-card/BracketBorderCard";
import EventManager from "../../common/event-manager/EventManager";

interface DeviceDetailsProps {
    eventManager: EventManager,
    deviceId: string
}

let DeviceDetails: React.FC<DeviceDetailsProps> = (props)=> {
    // api
    let deviceApi = new DeviceApi();
    let alarmEventApi = new AlarmEventApi();

    // state
    let [deviceView, setDeviceView] = useState(null);
    let [hasUnackedAlarm, setHasUnackedAlarm] = useState(false);
    
    // functions
    let fetchDeviceViewData = async (deviceId)=> {
        let deviceView = (await deviceApi.getDeviceViewByDeviceId(deviceId)).data.data;
        setDeviceView(deviceView);
        props.eventManager.notifyDeviceViewUpdated(deviceView);
    }

    let formatLastOnlineTime = (timestamp: number | string)=> {
        return TimeUtils.formatLastTime(timestamp);
    }

    // effect
    useEffect(()=> {
        fetchDeviceViewData(props.deviceId);

        let loadAlarmStatus = async ()=> {
            try {
                let resp = (await alarmEventApi.queryViews({
                    deviceId: props.deviceId,
                    acked: false,
                    pageNo: 1,
                    pageSize: 50,
                }));
                let elements = resp?.data?.data?.elements || [];
                setHasUnackedAlarm(elements.length > 0);
            } catch (e) {
                // ignore errors and keep previous state
            }
        };

        // initial load
        loadAlarmStatus();

        let refreshTask = setInterval(async ()=> {
            await fetchDeviceViewData(props.deviceId);
            await loadAlarmStatus();
        }, 5000);

        return ()=> {
            clearInterval(refreshTask);
        }
    }, []);

    useEffect(()=> {
        let originalBackground = document.body.style.backgroundColor;
        document.body.style.backgroundColor = '#2A2A2A';
        return ()=> {
            document.body.style.backgroundColor = originalBackground;
        };
    }, []);

    // render
    return (
        deviceView ? <DeviceDetailsWrapper>
            <BracketBorderCard>
                <InfoItem>
                    <InfoLabel>设备名称</InfoLabel>
                    <InfoValue>{deviceView.device.name}</InfoValue>
                </InfoItem>
            </BracketBorderCard>
            <BracketBorderCard>
                <InfoItem>
                    <InfoLabel>设备状态</InfoLabel>
                    <InfoValue><DeviceStatus status={deviceView.device.status} /></InfoValue>
                </InfoItem>
            </BracketBorderCard>
            <BracketBorderCard>
                <InfoItem>
                    <InfoLabel>告警状态</InfoLabel>
                    <InfoValue>
                        {hasUnackedAlarm ? <>告警<ExclamationCircleFilled style={{color: '#FF4D4F', fontSize: '18px', margin: '5px'}} /></> : <>正常<CheckCircleFilled style={{color: '#00AF50', fontSize: '18px', margin: '5px'}} /></>}
                    </InfoValue>
                </InfoItem>
            </BracketBorderCard>
           
        </DeviceDetailsWrapper>
        : <DeviceDetailsWrapper></DeviceDetailsWrapper>
    )
};

export default DeviceDetails;